<template>
    <div v-if="$store.state.selectedAcademy">
        <!-- Mobile: fullscreen dialog -->
        <template v-if="isSmallerDisplay()">
            <v-flex class="clickable" text-xs-center layout align-center justify-center @click.stop="openMobileMenu">
                <v-avatar size="42" :class="['clickable', darkTheme ? 'transparent' : 'grey lighten-4']">
                    <ImageDisplay v-if="$store.state.userImage" :src="$store.state.userImage" alt="avatar" />
                    <v-avatar size="36" :color="darkTheme ? 'plusIndigoDarken1' : 'plusIndigoLighten3'" v-else>
                        <span class="font-roboto white--text text-subtitle-1">{{
                            getInitials(`${$store.state.user.fName} ${$store.state.user.lName}`)
                        }}</span>
                    </v-avatar>
                </v-avatar>
            </v-flex>

            <v-dialog v-model="isOpen" fullscreen transition="dialog-bottom-transition">
                <v-card flat color="plusBackground" class="user-menu-mobile-card rounded-0">
                    <v-btn icon size="large" @click.stop="closeMobileMenu" aria-label="Close menu" class="close-icon">
                        <v-icon size="36" color="plusTextPrimary">mdi-close</v-icon>
                    </v-btn>

                    <v-list class="pa-0 user-menu-mobile-list">
                        <v-list-item class="py-6 px-6">
                            <v-list-item-avatar size="48" class="mr-4">
                                <ImageDisplay v-if="$store.state.userImage" :src="$store.state.userImage"
                                    alt="avatar" />
                                <v-avatar v-else size="48"
                                    :color="darkTheme ? 'plusIndigoDarken1' : 'plusIndigoLighten3'">
                                    <span class="font-roboto white--text text-subtitle-1">{{
                                        getInitials(`${$store.state.user.fName} ${$store.state.user.lName}`)
                                    }}</span>
                                </v-avatar>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title class="py-1 font-roboto font-weight-medium plusTextPrimary--text"
                                    style="font-size: 1.4rem;">
                                    {{ fullName }}
                                </v-list-item-title>
                                <v-list-item-subtitle class="font-roboto plusTextSecondary--text">
                                    {{ userEmail }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-divider />

                        <v-list-item @click="goToUpgradePlanMobile" class="my-4 pr-6 pl-9 pr-0" style="height: 1.5rem;">
                            <div class="d-flex flex-row">
                                <IconWorkspacePremium color="plusNavActiveText" class="mr-4 d-flex" size="20px" />
                                <div class="font-roboto text-body-1 plusNavActiveText--text">
                                    {{ $t(planActionLabelKey) }}
                                </div>
                            </div>
                        </v-list-item>

                        <v-list-item v-if="showNewDesignToggle" class="mt-2 my-4 pr-6 pl-9 pr-0"
                            style="height: 1.5rem;">
                            <div class="d-flex flex-row align-center justify-space-between flex-grow-1">
                                <div class="d-flex flex-row align-center font-roboto text-body-1">
                                    <v-icon color="plusNavActiveText" class="mr-4">mdi-alert-decagram-outline</v-icon>
                                    <div class="font-roboto text-body-1 plusNavActiveText--text">{{
                                        $t("message.new_design") }}
                                    </div>
                                </div>
                                <v-switch class="ma-0 pa-0" v-model="localAdminPlusVersion" @change="onAdminPlusSwitch"
                                    inset dense color="plusIndigoLighten1" @click.stop hide-details />
                            </div>
                        </v-list-item>

                        <v-list-item v-if="!$store.state.inApp" class="d-flex my-4 pr-6 pl-9 pr-0"
                            style="height: 1.5rem;">
                            <div class="d-flex flex-row align-center justify-space-between flex-grow-1">
                                <div class="d-flex flex-row align-center">
                                    <v-icon color="plusNavActiveText" class="mr-4">mdi-weather-night</v-icon>
                                    <span class="font-roboto text-body-1 plusNavActiveText--text">{{
                                        $t("message.dark_mode")
                                        }}</span>
                                </div>
                                <v-switch v-model="localDarkTheme" @change="onThemeSwitch" inset dense
                                    color="plusIndigoLighten1" @click.stop />
                            </div>
                        </v-list-item>

                        <v-list-item @click="goToReleases(true)" class="my-4 pr-6 pl-9 pr-0" style="height: 1.5rem;">
                            <div class="d-flex flex-row align-center justify-space-between flex-grow-1">
                                <div class="d-flex flex-row align-center">
                                    <v-icon color="plusNavActiveText" class="mr-4">mdi-update</v-icon>
                                    <span class="font-roboto text-body-1 plusNavActiveText--text">{{
                                        $t("message.admin_plus_user_menu_release_notes") }}</span>
                                </div>
                            </div>
                        </v-list-item>

                        <v-list-item @click="openTechSupportMobile" class="my-4 pr-6 pl-9 pr-0" style="height: 1.5rem;">
                            <div class="d-flex flex-row align-center justify-space-between flex-grow-1">
                                <div class="d-flex flex-row align-center">
                                    <v-icon color="plusNavActiveText" class="mr-4">mdi-help-circle-outline</v-icon>
                                    <span class="font-roboto text-body-1 plusNavActiveText--text">{{
                                        $t("message.admin_plus_user_menu_help")
                                    }}</span>
                                </div>
                            </div>
                        </v-list-item>

                        <v-list-item @click="openFeedbackDialogMobile" class="my-4 pr-6 pl-9 pr-0"
                            style="height: 1.5rem;">
                            <div class="d-flex flex-row align-center justify-space-between flex-grow-1">
                                <div class="d-flex flex-row align-center">
                                    <v-icon color="plusNavActiveText"
                                        class="mr-4">mdi-message-reply-text-outline</v-icon>
                                    <span class="font-roboto text-body-1 plusNavActiveText--text">{{
                                        $t("message.admin_plus_user_menu_send_feedback") }}</span>
                                </div>
                            </div>
                        </v-list-item>

                        <v-list-item v-if="!$store.state.inApp" @click="logoutMobile" class="mt-4 pb-4 pr-6 pl-9 pr-0">
                            <div class="d-flex flex-row align-center justify-space-between flex-grow-1">
                                <div class="d-flex flex-row align-center">
                                    <v-icon color="plusNavActiveText" class="mr-4">mdi-logout</v-icon>
                                    <span class="font-roboto text-body-1 plusNavActiveText--text">{{
                                        $t("message.admin_plus_user_menu_sign_out")
                                    }}</span>
                                </div>
                            </div>
                        </v-list-item>

                        <v-list-item v-if="isSystemAdmin()" @click="copyToClipboardMobile($store.state.selectedAcademy)"
                            class="px-6">
                            <v-list-item-icon class="mr-4">
                                <v-icon color="plusNavActiveText">mdi-fingerprint</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title class="font-roboto text-body-1 plusNavActiveText--text">
                                    Academy ID
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item v-if="isSystemAdmin() && stripeAccountId"
                            @click="copyToClipboardMobile(stripeAccountId)" class="px-6">
                            <v-list-item-icon class="mr-4">
                                <v-icon color="plusNavActiveText">mdi-fingerprint</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title class="font-roboto text-body-1 plusNavActiveText--text">
                                    Stripe Account ID
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item v-if="isSystemAdmin()" @click="reloadAndRefreshMobile(false)" class="py-3 px-6">
                            <div class="d-flex flex-row align-center justify-space-between flex-grow-1">
                                <div class="d-flex flex-row align-center">
                                    <v-icon color="plusNavActiveText" class="mr-4">mdi-information-outline</v-icon>
                                    <span class="font-roboto text-body-2 plusNavActiveText--text">Version v{{ appVersion
                                        }}</span>
                                    <span v-if="isSystemAdmin()" class="ml-1 plusTextSecondary--text">[InApp: {{
                                        $store.state.inApp
                                        }}]</span>
                                </div>
                            </div>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-dialog>
        </template>

        <!-- Desktop: dropdown menu -->
        <v-menu v-else v-model="isOpen" offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-flex class="clickable" v-bind="attrs" v-on="on" text-xs-center layout align-center justify-center>
                    <v-avatar size="42" :class="['clickable', darkTheme ? 'transparent' : 'grey lighten-4']">
                        <ImageDisplay v-if="$store.state.userImage" :src="$store.state.userImage" alt="avatar" />
                        <v-avatar size="36" :color="darkTheme ? 'plusIndigoDarken1' : 'plusIndigoLighten3'" v-else>
                            <span class="font-roboto white--text text-subtitle-1">{{
                                getInitials(`${$store.state.user.fName} ${$store.state.user.lName}`)
                            }}</span>
                        </v-avatar>
                    </v-avatar>
                </v-flex>
            </template>

            <v-list class="pa-0 user-menu-list" style="min-width: 320px;">
                <v-list-item class="py-4">
                    <v-list-item-avatar size="42" class="mr-4">
                        <ImageDisplay v-if="$store.state.userImage" :src="$store.state.userImage" alt="avatar" />
                        <v-avatar v-else size="42" :color="darkTheme ? 'plusIndigoDarken1' : 'plusIndigoLighten3'">
                            <span class="font-roboto white--text text-subtitle-1">{{
                                getInitials(`${$store.state.user.fName} ${$store.state.user.lName}`)
                            }}</span>
                        </v-avatar>
                    </v-list-item-avatar>
                    <div class="pr-6">
                        <div class="py-1 font-roboto font-weight-medium" style="font-size: 1.4rem;">
                            {{ fullName }}
                        </div>
                        <div class="font-roboto text-body-1 plusTextSecondary--text">
                            {{ userEmail }}
                        </div>
                    </div>
                </v-list-item>

                <v-divider />

                <v-list-item @click="goToUpgradePlan" class="my-4 pr-4 pl-9 pr-0" style="height: 1.5rem;">
                    <div class="d-flex flex-row">
                        <IconWorkspacePremium color="plusNavActiveText" class="mr-4 d-flex" size="20px" />
                        <div class="font-roboto text-body-1 plusNavActiveText--text">
                            {{ $t(planActionLabelKey) }}
                        </div>
                    </div>
                </v-list-item>

                <v-divider />


                <v-list-item v-if="showNewDesignToggle" class="mt-2 my-4 pr-4 pl-9 pr-0" style="height: 1.5rem;">
                    <div class="d-flex flex-row align-center justify-space-between flex-grow-1">
                        <div class="d-flex flex-row align-center font-roboto text-body-1">
                            <v-icon color="plusNavActiveText" class="mr-4">mdi-alert-decagram-outline</v-icon>
                            <div class="font-roboto text-body-1 plusNavActiveText--text">{{ $t("message.new_design") }}
                            </div>
                        </div>
                        <v-switch class="ma-0 pa-0" v-model="localAdminPlusVersion" @change="onAdminPlusSwitch" inset
                            dense color="plusIndigoLighten1" @click.stop hide-details />
                    </div>
                </v-list-item>

                <v-list-item v-if="!$store.state.inApp" class="d-flex my-4 pr-4 pl-9 pr-0" style="height: 1.5rem;">
                    <div class="d-flex flex-row align-center justify-space-between flex-grow-1">
                        <div class="d-flex flex-row align-center">
                            <v-icon color="plusNavActiveText" class="mr-4">mdi-weather-night</v-icon>
                            <span class="font-roboto text-body-1 plusNavActiveText--text">{{ $t("message.dark_mode")
                            }}</span>
                        </div>
                        <v-switch v-model="localDarkTheme" @change="onThemeSwitch" inset dense
                            color="plusIndigoLighten1" @click.stop />
                    </div>
                </v-list-item>

                <v-list-item @click="goToReleases()" class="my-4 pr-4 pl-9 pr-0" style="height: 1.5rem;">
                    <div class="d-flex flex-row align-center justify-space-between flex-grow-1">
                        <div class="d-flex flex-row align-center">
                            <v-icon color="plusNavActiveText" class="mr-4">mdi-update</v-icon>
                            <span class="font-roboto text-body-1 plusNavActiveText--text">{{
                                $t("message.admin_plus_user_menu_release_notes") }}</span>
                        </div>
                    </div>
                </v-list-item>

                <v-list-item @click="openTechSupport" class="my-4 pr-4 pl-9 pr-0" style="height: 1.5rem;">
                    <div class="d-flex flex-row align-center justify-space-between flex-grow-1">
                        <div class="d-flex flex-row align-center">
                            <v-icon color="plusNavActiveText" class="mr-4">mdi-help-circle-outline</v-icon>
                            <span class="font-roboto text-body-1 plusNavActiveText--text">{{
                                $t("message.admin_plus_user_menu_help")
                            }}</span>
                        </div>
                    </div>
                </v-list-item>

                <v-list-item @click="openFeedbackDialog" class="my-4 pr-4 pl-9 pr-0" style="height: 1.5rem;">
                    <div class="d-flex flex-row align-center justify-space-between flex-grow-1">
                        <div class="d-flex flex-row align-center">
                            <v-icon color="plusNavActiveText" class="mr-4">mdi-message-reply-text-outline</v-icon>
                            <span class="font-roboto text-body-1 plusNavActiveText--text">{{
                                $t("message.admin_plus_user_menu_send_feedback") }}</span>
                        </div>
                    </div>
                </v-list-item>

                <v-list-item v-if="!$store.state.inApp" @click="logout" class="mt-4 pb-4 pr-4 pl-9 pr-0">
                    <div class="d-flex flex-row align-center justify-space-between flex-grow-1">
                        <div class="d-flex flex-row align-center">
                            <v-icon color="plusNavActiveText" class="mr-4">mdi-logout</v-icon>
                            <span class="font-roboto text-body-1 plusNavActiveText--text">{{
                                $t("message.admin_plus_user_menu_sign_out")
                            }}</span>
                        </div>
                    </div>
                </v-list-item>

                <v-list-item v-if="isSystemAdmin()" @click="copyToClipboard($store.state.selectedAcademy)">
                    <v-list-item-icon class="mr-4">
                        <v-icon>mdi-fingerprint</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="font-roboto text-body-1">
                            Academy ID
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="isSystemAdmin() && stripeAccountId" @click="copyToClipboard(stripeAccountId)">
                    <v-list-item-icon class="mr-4">
                        <v-icon>mdi-fingerprint</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="font-roboto text-body-1">
                            Stripe Account ID
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="isSystemAdmin()" @click="reloadAndRefresh(false)" class="py-3 pr-4 pl-9 pr-0">
                    <div class="d-flex flex-row align-center justify-space-between flex-grow-1">
                        <div class="d-flex flex-row align-center">
                            <v-icon color="plusNavActiveText" class="mr-4">mdi-information-outline</v-icon>
                            <span class="font-roboto text-body-2 plusNavActiveText--text">Version v{{ appVersion
                            }}</span>
                            <span v-if="isSystemAdmin()" class="ml-1">[InApp: {{ $store.state.inApp }}]</span>
                        </div>
                    </div>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<style scoped>
.user-menu-mobile-card>>>.v-list,
.user-menu-mobile-card>>>.v-list-item {
    background-color: transparent !important;
}

.user-menu-mobile-list {
    background: transparent;
}

.user-menu-mobile-divider {
    border-color: rgba(255, 255, 255, 0.18) !important;
}

.close-icon {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 5;
}
</style>

<style>
.user-menu-mobile-card.v-card {
    height: 100vh !important;
    overflow-y: auto !important;
}

.theme--dark .user-menu-list {
    background-color: #212121 !important;
}


.v-application .v-list .v-input--switch .v-input--switch__track {
    opacity: 1 !important;
    background-color: rgba(92, 107, 192, 0.3) !important;
}

.v-application .v-list .v-input--switch.v-input--is-dirty .v-input--switch__track {
    opacity: 1 !important;
    background-color: #1A237E !important;
}

.theme--dark .v-application .v-list .v-input--switch.v-input--is-dirty .v-input--switch__track,
.theme--dark.v-application .v-list .v-input--switch.v-input--is-dirty .v-input--switch__track {
    background-color: #5C6BC0 !important;
}

.v-application .v-list .v-input--switch.v-input--is-dirty .v-input--switch__thumb {
    background-color: #FFFFFF !important;
}

.user-menu-list .v-list-item:not(:first-child):hover::before {
    opacity: 0;
}

.user-menu-list .v-list-item:not(:first-child):hover {
    background-color: #E8EAF6;
}

.theme--dark .user-menu-list .v-list-item:not(:first-child):hover {
    background-color: #424242;
}
</style>

<script>
import IconWorkspacePremium from "@/components/displays/icons/IconWorkspacePremium.vue";

export default {
    components: { IconWorkspacePremium },
    props: {
        darkTheme: Boolean,
        appVersion: String,
        stripeAccountId: String,
    },
    data() {
        return {
            isOpen: false,
            localDarkTheme: this.darkTheme,
            localAdminPlusVersion: this.$store.state.adminPlusVersion,
        };
    },
    computed: {
        showNewDesignToggle() {
            return true;
        },
        fullName() {
            const f = this.$store.state?.user?.fName || "";
            const l = this.$store.state?.user?.lName || "";
            const raw = `${f} ${l}`.trim();
            return raw || this.$t("message.user");
        },
        userEmail() {
            return this.$store.state.userEmail;
        },
        planActionLabelKey() {
            return this.$store.state.academyAdminStatus?.isTrial === false
                ? "message.manage_plan"
                : "message.upgrade_plan";
        },
    },
    watch: {
        darkTheme(val) {
            this.localDarkTheme = val;
        },
        "$store.state.adminPlusVersion"(val) {
            this.localAdminPlusVersion = val;
        },
    },
    methods: {
        goToReleases(mobile) {
            this.navigateTo({ name: 'releases' });
            if (mobile)
                this.closeMobileMenu();
        },
        isSmallerDisplay() {
            /** @type {any} */
            const root = this.$root;
            return typeof root?.isSmallerDisplay === "function" ? root.isSmallerDisplay() : false;
        },
        openMobileMenu() {
            this.isOpen = true;
        },
        closeMobileMenu() {
            this.isOpen = false;
        },
        onThemeSwitch() {
            this.$emit("toggle-theme", this.localDarkTheme);
        },
        onAdminPlusSwitch() {
            this.$emit("toggle-admin-plus", this.localAdminPlusVersion);
        },
        goToUpgradePlan() {
            this.$router.push({ name: "upgrade-plan-adminplus" });
        },
        goToUpgradePlanMobile() {
            this.goToUpgradePlan();
            this.closeMobileMenu();
        },
        openFeedbackDialog() {
            this.$emit("open-feedback");
        },
        openFeedbackDialogMobile() {
            this.openFeedbackDialog();
            this.closeMobileMenu();
        },
        openTechSupport() {
            this.$emit("open-tech-support");
        },
        openTechSupportMobile() {
            this.openTechSupport();
            this.closeMobileMenu();
        },
        logout() {
            this.$emit("logout");
        },
        logoutMobile() {
            this.logout();
            this.closeMobileMenu();
        },
        /** @param {boolean} releases */
        reloadAndRefresh(releases) {
            this.$emit("reload-refresh", releases);
        },
        /** @param {boolean} releases */
        reloadAndRefreshMobile(releases) {
            this.reloadAndRefresh(releases);
            this.closeMobileMenu();
        },
        /** @param {any} value */
        copyToClipboard(value) {
            this.$emit("copy", value);
        },
        /** @param {any} value */
        copyToClipboardMobile(value) {
            this.copyToClipboard(value);
            this.closeMobileMenu();
        },
    },
};
</script>